// extracted by mini-css-extract-plugin
export default {"content":"LimitedProfileEntry--content--1H4xC","description":"LimitedProfileEntry--description--UWW4C"};